export default {
  // 用户数据
  userInfo: {},
  baseURL: "https://siteh5.lightcourse.com/pc/home",
  uploadURL: "https://siteh5.lightcourse.com/pc/uploads",
  crmURL: "https://crmh5.lightcourse.com/",
  mobile: false,
}



// WEBPACK FOOTER //
// ./src/store/state.js